/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ShipmentState } from "./ShipmentState";
import {
  ShipmentStateFromJSON,
  ShipmentStateFromJSONTyped,
  ShipmentStateToJSON,
  ShipmentStateToJSONTyped,
} from "./ShipmentState";

/**
 *
 * @export
 * @interface CompanyBookedShipmentRow
 */
export interface CompanyBookedShipmentRow {
  /**
   *
   * @type {string}
   * @memberof CompanyBookedShipmentRow
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyBookedShipmentRow
   */
  carrierIdentifier: string;
  /**
   *
   * @type {ShipmentState}
   * @memberof CompanyBookedShipmentRow
   */
  shipmentState: ShipmentState;
  /**
   *
   * @type {LocalDate}
   * @memberof CompanyBookedShipmentRow
   */
  pickupDate: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof CompanyBookedShipmentRow
   */
  deliveryDate?: LocalDate | null;
  /**
   *
   * @type {string}
   * @memberof CompanyBookedShipmentRow
   */
  proNumber?: string | null;
  /**
   *
   * @type {number}
   * @memberof CompanyBookedShipmentRow
   */
  price: number;
  /**
   *
   * @type {string}
   * @memberof CompanyBookedShipmentRow
   */
  pickupLocation: string;
  /**
   *
   * @type {string}
   * @memberof CompanyBookedShipmentRow
   */
  deliveryLocation: string;
  /**
   *
   * @type {string}
   * @memberof CompanyBookedShipmentRow
   */
  brokerName?: string | null;
}

/**
 * Check if a given object implements the CompanyBookedShipmentRow interface.
 */
export function instanceOfCompanyBookedShipmentRow(
  value: object,
): value is CompanyBookedShipmentRow {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("shipmentState" in value) || value["shipmentState"] === undefined)
    return false;
  if (!("pickupDate" in value) || value["pickupDate"] === undefined)
    return false;
  if (!("price" in value) || value["price"] === undefined) return false;
  if (!("pickupLocation" in value) || value["pickupLocation"] === undefined)
    return false;
  if (!("deliveryLocation" in value) || value["deliveryLocation"] === undefined)
    return false;
  return true;
}

export function CompanyBookedShipmentRowFromJSON(
  json: any,
): CompanyBookedShipmentRow {
  return CompanyBookedShipmentRowFromJSONTyped(json, false);
}

export function CompanyBookedShipmentRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyBookedShipmentRow {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    carrierIdentifier: json["carrierIdentifier"],
    shipmentState: ShipmentStateFromJSON(json["shipmentState"]),
    pickupDate: json["pickupDate"],
    deliveryDate:
      json["deliveryDate"] == null ? undefined : json["deliveryDate"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    price: json["price"],
    pickupLocation: json["pickupLocation"],
    deliveryLocation: json["deliveryLocation"],
    brokerName: json["brokerName"] == null ? undefined : json["brokerName"],
  };
}

export function CompanyBookedShipmentRowToJSON(
  json: any,
): CompanyBookedShipmentRow {
  return CompanyBookedShipmentRowToJSONTyped(json, false);
}

export function CompanyBookedShipmentRowToJSONTyped(
  value?: CompanyBookedShipmentRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    carrierIdentifier: value["carrierIdentifier"],
    shipmentState: ShipmentStateToJSON(value["shipmentState"]),
    pickupDate: value["pickupDate"],
    deliveryDate: value["deliveryDate"],
    proNumber: value["proNumber"],
    price: value["price"],
    pickupLocation: value["pickupLocation"],
    deliveryLocation: value["deliveryLocation"],
    brokerName: value["brokerName"],
  };
}
